import i18n from "../../../../i18n/i18n";
import ModifyItem from "../../dictionary/modifyItem/modifyItem";
import {withRouter} from "react-router";
import { ShipownerModel } from "../../../models/shipowners";
import { ShipownerService } from "../../../services/shipownerService";
import ShipownerForm from "../shipownerForm/shipownerForm";


class ModifyShipowner extends ModifyItem<ShipownerModel> {
    constructor(props: any) {
        super(props);
    }

    async componentDidMount() {
        this.getItem(await ShipownerService.getShipowner(this.props.match.params?.id));
    }

    render() {
        return (
            <div className="modify-shipowner modify-record">
                <div className="content">
                    {this.renderHeader(i18n.t("dictionaries.shipowners.actions.modifyShipowner.header"))}
                    {this.renderContent(<ShipownerForm isUpdate={true} shipownerData={this.state.item}/>)}
                </div>
            </div>
        );
    }
}
export default withRouter(ModifyShipowner);

